import { INavMenuItem } from "@types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useMobileMenu = (items: INavMenuItem[] | null) => {
  const { pathname } = useLocation();
  const [openMenus, setOpenMenus] = useState<Record<string, boolean>>({});

  useEffect(() => {
    if (!items) return;

    const initialState: Record<string, boolean> = {};

    const traverse = (menu: INavMenuItem[]) => {
      menu.forEach((item) => {
        if (item.subs && item.subs.length > 0) {
          if (
            pathname.includes(item.to) ||
            item.subs.some((sub) => pathname.includes(sub.to))
          ) {
            initialState[item.text] = true;
          }
          traverse(item.subs);
        }
      });
    };

    traverse(items);

    setOpenMenus((prev) => {
      const isEqual =
        Object.keys(prev).length === Object.keys(initialState).length &&
        Object.keys(prev).every((key) => prev[key] === initialState[key]);
      return isEqual ? prev : initialState;
    });
  }, [items, pathname]);

  const toggleMenu = (text: string) => {
    setOpenMenus((prev) => ({ ...prev, [text]: !prev[text] }));
  };

  return { openMenus, toggleMenu };
};
